import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {ApiService} from '../../../../services/api.service';
import {SweetalertService} from '../../../../services/sweetalert.service';
import {ProposalManageService} from '../proposal-manage/proposal-manage.service';
import {ProposalListService} from '../proposal-list/proposal-list.service';
import {PROPOSAL_STATUS} from '../../../../enums/proposal-status.enum';

@Component({
  selector: 'app-proposal-settlements',
  templateUrl: './proposal-settlements.component.html',
  styleUrls: ['./proposal-settlements.component.scss']
})
export class ProposalSettlementsComponent implements OnInit {
  public fileToUpload: File = null;
  public files = [];
  public PROPOSAL_STATUS: typeof PROPOSAL_STATUS = PROPOSAL_STATUS;
  @Input() public proposal;
  private isNew;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private sweetalertService: SweetalertService,
    private proposalManageService: ProposalManageService,
    private dialogRef: MatDialog,
    private proposalAgreementService: ProposalListService,
  ) {
  }

  ngOnInit(): void {
    if (this.proposal.proposalSettlement) {
      this.isNew = false;
      this.files = this.proposal.proposalSettlement.files;
    } else {
      this.isNew = true;
      this.proposal.proposalSettlement = {
        comment: '',
        isCorrect: false,
        files: [],
        proposal: this.proposal.id
      };
    }
  }

  public deleteFile(id: number) {
    let filePosition;

    for (let x = 0; x < this.files.length; x++) {
      if (this.files[x].id === id) {
        filePosition = x;
        break;
      }
    }

    this.files.splice(filePosition, 1);
  }

  public uploadFile(files: FileList) {
    this.fileToUpload = files.item(0);

    this.apiService.postFile(this.fileToUpload).subscribe((response: any) => {
      this.files.push(response.data);
      this.fileToUpload = null;
    }, error => {
      this.sweetalertService.connectionError();
      this.fileToUpload = null;
    });
  }

  public onFormSubmit() {
    this.proposal.proposalSettlement.proposal = this.proposal.id;
    this.proposal.proposalSettlement.files = [];
    for (let x = 0; x < this.files.length; x++) {
      this.proposal.proposalSettlement.files.push(this.files[x].id);
    }

    if (this.isNew) {
      this.apiService.postProposalSettlement(this.proposal.proposalSettlement).subscribe((response: any) => {
        this.sweetalertService.success();
        this.proposalAgreementService.refreshProposalList();
        this.dialogRef.closeAll();
      }, error => {
        this.sweetalertService.connectionError();
      });
    } else {
      // tslint:disable-next-line:max-line-length
      this.apiService.updateProposalSettlement(this.proposal.proposalSettlement.id, this.proposal.proposalSettlement).subscribe((response: any) => {
        this.sweetalertService.success();
        this.proposalAgreementService.refreshProposalList();
        this.dialogRef.closeAll();
      }, error => {
        this.sweetalertService.connectionError();
      });
    }
  }
}
